<template>
  <div class="menu-container">
    <div class="tabs">
      <button :class="{ active: activeTab === 'menu' }" @click="activeTab = 'menu'">本周菜单</button>
      <button :class="{ active: activeTab === 'dishes' }" @click="activeTab = 'dishes'">菜品管理</button>
      <button :class="{ active: activeTab === 'add' }" @click="activeTab = 'add'">添加</button>
    </div>
    <div v-if="activeTab === 'menu'">
      <!-- 本周菜单 -->
      <form @submit.prevent="saveMenu">
        <div v-for="(day, index) in 7" :key="index" class="menu-day">
          <div class="menu-day-title">
            <label>{{ formatDay(index) }}</label>
          </div>
          <div class="meal-type">
            <label>早餐：</label>
            <div class="dish-group">
              <div v-for="dish in breakfastDishes" :key="dish.id" class="dish-item">
                <input type="checkbox" :value="dish" v-model="selectedBreakfastDishes[index]" />
                <span>{{ dish.name }}</span>
              </div>
            </div>
          </div>
          <div class="meal-type">
            <label>午餐：</label>
            <div class="dish-group">
              <div v-for="dish in lunchDishes" :key="dish.id" class="dish-item">
                <input type="checkbox" :value="dish" v-model="selectedLunchDishes[index]" />
                <span>{{ dish.name }}</span>
              </div>
            </div>
          </div>
          <div class="meal-type">
            <label>晚餐：</label>
            <div class="dish-group">
              <div v-for="dish in dinnerDishes" :key="dish.id" class="dish-item">
                <input type="checkbox" :value="dish" v-model="selectedDinnerDishes[index]" />
                <span>{{ dish.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <button type="submit" class="save-button">保存菜单</button>
      </form>
    </div>
    <div v-if="activeTab === 'dishes'">
      <!-- 菜品管理 -->
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>类型</th>
            <th>名称</th>
            <th>修改时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="dish in dishes" :key="dish.id">
            <td>{{ dish.id }}</td>
            <td :class="{'type-breakfast': dish.leixing === '早餐', 'type-lunch': dish.leixing === '中餐', 'type-dinner': dish.leixing === '晚餐'}">{{ dish.leixing }}</td>
            <td>{{ dish.name }}</td>
            <td>{{ dish.time }}</td>
            <td>
              <button class="delete-button" @click="deleteDish(dish.id)">删除</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="activeTab === 'add'">
      <form @submit.prevent="addDish">
        <div class="form-group">
          <label>菜品名称</label>
          <input type="text" v-model="newDish.name" required />
        </div>
        <div class="form-group">
          <label style="margin-right: 40px;">类型</label>
          <select v-model="newDish.type">
            <option value="早餐">早餐</option>
            <option value="中餐">中餐</option>
            <option value="晚餐">晚餐</option>
          </select>
        </div>
        <button type="submit" class="save-button">保存</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
  return {
    activeTab: 'menu',
    newDish: {
      name: '',
      type: '早餐',
      status: '显示'
    },
    dishes: [],
    breakfastDishes: [],
    lunchDishes: [],
    dinnerDishes: [],
    selectedBreakfastDishes: Array.from({ length: 7 }, () => []),
    selectedLunchDishes: Array.from({ length: 7 }, () => []),
    selectedDinnerDishes: Array.from({ length: 7 }, () => []),
    menuData: null // 添加存储本周菜单数据的变量
  };
},
  methods: {
    formatDay(index) {
      const days = ['星期一', '星期二', '星期三', '星期四', '星期五','星期六','星期日'];
      return days[index];
    },
    async fetchDishes() {
      try {
        const response = await this.$axios.get('/api/show_caiping');
        const data = response.data;
        if (data.code === 0) {
          this.dishes = data.data;
          this.breakfastDishes = this.dishes.filter(dish => dish.leixing === '早餐');
          this.lunchDishes = this.dishes.filter(dish => dish.leixing === '中餐');
          this.dinnerDishes = this.dishes.filter(dish => dish.leixing === '晚餐');
        } else {
          console.error('Failed to fetch dishes:', data.message);
        }
      } catch (error) {
        console.error('Error fetching dishes:', error);
      }
    },
    async addDish() {
      const dishData = {
        leixing: this.newDish.type,
        name: this.newDish.name
      };

      try {
        const response = await this.$axios.post('/api/add_caiping', dishData);
        const data = response.data;
        if (data.code === 0) {
          this.$message.success({
            message: '菜品添加成功',
            duration: 2000
          });
          this.newDish = { name: '', type: '早餐', status: '显示' };
          this.fetchDishes(); // 刷新菜品列表
        } else {
          this.$message.error({
            message: '菜品添加失败',
            duration: 2000
          });
        }
      } catch (error) {
        console.error('Error adding dish:', error);
      }
    },
    async saveMenu() {
      const menuData = {
        breakfast: this.selectedBreakfastDishes.map(dayDishes => dayDishes.map(dish => dish.name).join(',')),
        lunch: this.selectedLunchDishes.map(dayDishes => dayDishes.map(dish => dish.name).join(',')),
        dinner: this.selectedDinnerDishes.map(dayDishes => dayDishes.map(dish => dish.name).join(','))
      };
      console.log(menuData);

      try {
        const response = await this.$axios.post('/api/save_menu', menuData);
        const data = response.data;
        if (data.code === 0) {
          this.$message.success({
            message: '菜单保存成功',
            duration: 2000
          });
        } else {
          this.$message.error({
            message: '菜单保存失败',
            duration: 2000
          });
        }
      } catch (error) {
        console.error('Error saving menu:', error);
      }
    },
    editDish(id) {
      // Implement edit dish logic
      console.log('Edit dish:', id);
    },
    async deleteDish(id) {
      if (confirm('确定要删除这个菜品吗？')) {
        try {
          const response = await this.$axios.post('/api/delete_caiping', { id });
          const data = response.data;
          if (data.code === 0) {
            this.$message.success({
              message: '菜品删除成功',
              duration: 2000
            });
            this.fetchDishes(); // 刷新菜品列表
          } else {
            this.$message.error({
              message: '菜品删除失败',
              duration: 2000
            });
          }
        } catch (error) {
          console.error('Error deleting dish:', error);
        }
      }
    },
    async fetchMenu() {
    try {
      const response = await this.$axios.get('/api/show_caidan');
      const data = response.data;
      if (data.code === 0) {
        this.menuData = data.data; // 存储本周菜单数据
        console.log(this.menuData)
        this.updateSelectedDishes(); // 根据本周菜单数据更新选中的菜品
      } else {
        console.error('Failed to fetch menu:', data.message);
      }
    } catch (error) {
      console.error('Error fetching menu:', error);
    }
  },
  updateSelectedDishes() {
    // 遍历每天的菜单数据
    for (let i = 1; i <= 7; i++) {
      const zaocan = this.menuData[`zaocan${i}`];
      const wucan = this.menuData[`wucan${i}`];
      const wancan = this.menuData[`wancan${i}`];

      // 更新早餐选中的菜品
      if (zaocan) {
        const selectedBreakfastDish = this.breakfastDishes.find(dish => dish.name === zaocan);
        if (selectedBreakfastDish) {
          this.selectedBreakfastDishes[i - 1].push(selectedBreakfastDish);
        }
      }

      // 更新午餐选中的菜品
      if (wucan) {
        const selectedLunchDish = this.lunchDishes.find(dish => dish.name === wucan);
        if (selectedLunchDish) {
          this.selectedLunchDishes[i - 1].push(selectedLunchDish);
        }
      }

      // 更新晚餐选中的菜品
      if (wancan) {
        const selectedDinnerDish = this.dinnerDishes.find(dish => dish.name === wancan);
        if (selectedDinnerDish) {
          this.selectedDinnerDishes[i - 1].push(selectedDinnerDish);
        }
      }
    }
  },
  },
  mounted() {
    this.fetchDishes();
    this.fetchMenu(); // 新增调用本周菜单的 API
  }
};
</script>

<style scoped>
.menu-container {
  background-color: #fff;
  padding: 20px;
}

.tabs {
  justify-content: space-between;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
}

.tabs button {
  padding: 8px 16px;
  border: 1px solid #ccc;
  cursor: pointer;
  background-color: #fff;
  color: #333;
}

.tabs button.active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.menu-day {
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.menu-day-title {
  font-weight: bold;
  margin-bottom: 10px;
}

.meal-type {
  margin-bottom: 10px;
}

.dish-group {
  display: flex;
  align-items: center;
}

.dish-item {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.dish-item input[type="checkbox"] {
  margin-right: 5px;
}

.type-breakfast {
  color: green;
}

.type-lunch {
  color: blue;
}

.type-dinner {
  color: orange;
}

.status-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}

.status-active {
  background-color: green;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
}

.edit-button {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.delete-button {
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.form-group label {
  margin-right: 10px;
}

.form-group input,
.form-group select {
  flex: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.save-button {
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>